import { isActionOf } from 'typesafe-actions';
import { RootState } from 'reducers/rootReducer';
import { Epic } from 'redux-observable';
import { RootAction } from 'actions/rootAction';
import { Services } from 'sideEffect/services';
import { filter, map, tap } from 'rxjs/operators';
import getConceptAvailability from './getConceptAvailability';
import { mapOption } from 'fp-ts/lib/Array';
import { loadSuccess } from 'viewConfig/actions';
import { fromNullable, fromEither } from 'fp-ts/lib/Option';
import { getViewConfiguration } from 'components/generics/utils/viewConfigUtils';
import { tryCatch } from 'fp-ts/lib/Either';
import { entityConceptExpressionsGenerated } from './actions';
import { CONCEPT_EXPRESSIONS_LOCALSTORAGE_KEY } from './constants';
import storage from 'local-storage-fallback';
import { EntityFieldConceptExps } from './reducer';

const generateConceptAvailabilities: Epic<RootAction, RootAction, RootState, Services> = (action$, state$, services) =>
    action$.pipe(
        filter(isActionOf(loadSuccess)),
        map(({ payload: { viewConfig } }) => {
            const validConfigs = mapOption(Object.entries(viewConfig.views), ([viewName, view]) =>
                getConceptAvailability(
                    viewName,
                    view.entity,
                    viewConfig,
                    fromEither(
                        // this should take viewName
                        tryCatch(() => getViewConfiguration(viewConfig, viewName)).mapLeft(e => console.log(e)), // tslint:disable-line
                    ).chain(fromNullable),
                ),
            );
            const visibilityExps: EntityFieldConceptExps = Object.assign({}, ...validConfigs);
            return visibilityExps;
        }),
        tap((vExps: EntityFieldConceptExps) => {
            storage.setItem(CONCEPT_EXPRESSIONS_LOCALSTORAGE_KEY, JSON.stringify(vExps));
        }),
        map(e => {
            return entityConceptExpressionsGenerated(e);
        }),
    );
export default generateConceptAvailabilities;
